import { Col, Grid, Skeleton } from 'gu-ui-kit'
import React from 'react'
import styles from 'modules/Services/NetworksList/services-list.module.scss'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const ServicesListSkeleton = () => {
  const breakpoint = useBreakpoint()
  return (
    <Skeleton shown>
      <Grid
        centered
        gap={16}
        fluid
        className={styles['list__container']}
        cols={breakpoint.xxl ? 4 : breakpoint.lg ? 3 : breakpoint.md ? 2 : 1}
      >
        {Array(10)
          .fill({})
          .map((item, i) => (
            <Col
              className={styles['list__col']}
              key={'skeleton-item-' + i}
            >
              <Skeleton
                shown
                width={'100%'}
              >
                <div className={styles['tile_skeleton']} />
              </Skeleton>
            </Col>
          ))}
      </Grid>
    </Skeleton>
  )
}

export default ServicesListSkeleton
